import { render, staticRenderFns } from "./SignUpComplete.vue?vue&type=template&id=5e88b223&scoped=true&"
import script from "./SignUpComplete.vue?vue&type=script&lang=ts&"
export * from "./SignUpComplete.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpComplete.vue?vue&type=style&index=0&id=5e88b223&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e88b223",
  null
  
)

export default component.exports